import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-3xl pb-8" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "bg-white rounded-lg pb-6 pt-3" }
const _hoisted_6 = { class: "grid grid-cols-1 mt-5 mx-7" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_9 = { class: "grid grid-cols-1 mt-5 mx-7" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "input-form-error-text"
}
const _hoisted_12 = {
  key: 1,
  class: "input-form-error-text"
}
const _hoisted_13 = { class: "grid grid-cols-1 mt-5 mx-7" }
const _hoisted_14 = { class: "grid grid-cols-1 rounded mt-5 mx-3" }
const _hoisted_15 = { class: "ml-4 mt-3 mb-3" }
const _hoisted_16 = { class: "md:text-base text-gray-500 text-light font-semibold" }
const _hoisted_17 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_18 = { class: "my-4" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "ml-3 md:text-base text-gray-500 text-light font-semibold" }
const _hoisted_21 = {
  key: 0,
  class: "ml-4 border-t border-gray-200"
}
const _hoisted_22 = { class: "my-4" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "ml-3 md:text-base text-gray-500 text-light" }
const _hoisted_25 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_26 = { class: "my-4" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = { class: "ml-3 md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_29 = {
  key: 0,
  class: "ml-4 border-t border-gray-200"
}
const _hoisted_30 = { class: "my-4" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "ml-3 md:text-base text-base text-gray-500 text-light" }
const _hoisted_33 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_34 = { class: "my-4" }
const _hoisted_35 = ["placeholder"]
const _hoisted_36 = { class: "ml-3 md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_37 = {
  key: 0,
  class: "ml-4 border-t border-gray-200"
}
const _hoisted_38 = { class: "my-4" }
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = { class: "ml-3 md:text-base text-gray-500 text-light" }
const _hoisted_41 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_42 = { class: "my-4" }
const _hoisted_43 = ["placeholder"]
const _hoisted_44 = { class: "ml-3 md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_45 = {
  key: 0,
  class: "ml-4 border-t border-gray-200"
}
const _hoisted_46 = { class: "my-4" }
const _hoisted_47 = ["placeholder"]
const _hoisted_48 = { class: "ml-3 md:text-base text-gray-500 text-light" }
const _hoisted_49 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_50 = { class: "my-4" }
const _hoisted_51 = ["placeholder"]
const _hoisted_52 = { class: "ml-3 md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_53 = {
  key: 0,
  class: "ml-4 border-t border-gray-200"
}
const _hoisted_54 = { class: "my-4" }
const _hoisted_55 = ["placeholder"]
const _hoisted_56 = { class: "ml-3 md:text-base text-gray-500 text-light" }
const _hoisted_57 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_58 = { class: "my-4" }
const _hoisted_59 = ["placeholder"]
const _hoisted_60 = { class: "ml-3 md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_61 = {
  key: 0,
  class: "ml-4 border-t border-gray-200"
}
const _hoisted_62 = { class: "my-4" }
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = { class: "ml-3 md:text-base text-gray-500 text-light" }
const _hoisted_65 = { class: "process-list-controls" }
const _hoisted_66 = ["disabled", "title", "onClick"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-10 h-10",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"
  })
], -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = ["disabled", "title", "onClick"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-10 h-10",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"
  })
], -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["title", "onClick"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("b", null, "×", -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "grid grid-cols-1 py-3 mx-6 my-4 flex-1 min-w-0" }
const _hoisted_76 = { class: "grid grid-cols-1" }
const _hoisted_77 = { class: "input-form-label" }
const _hoisted_78 = { class: "grid grid-cols-2 mt-4" }
const _hoisted_79 = { class: "" }
const _hoisted_80 = ["id", "name", "onUpdate:modelValue", "placeholder"]
const _hoisted_81 = ["for"]
const _hoisted_82 = { class: "mr-24" }
const _hoisted_83 = ["id", "name", "onUpdate:modelValue", "placeholder"]
const _hoisted_84 = ["for"]
const _hoisted_85 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_86 = { class: "input-form-label" }
const _hoisted_87 = {
  key: 0,
  class: "grid grid-cols-1 mt-4"
}
const _hoisted_88 = { class: "input-form-label" }
const _hoisted_89 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_90 = { class: "input-form-label" }
const _hoisted_91 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_92 = { class: "input-form-label" }
const _hoisted_93 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_94 = { class: "input-form-label" }
const _hoisted_95 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_96 = { class: "grid grid-cols-4" }
const _hoisted_97 = ["id", "name", "onUpdate:modelValue", "placeholder"]
const _hoisted_98 = ["for"]
const _hoisted_99 = ["id", "name", "onUpdate:modelValue", "placeholder"]
const _hoisted_100 = ["for"]
const _hoisted_101 = ["id", "name", "onUpdate:modelValue", "placeholder"]
const _hoisted_102 = ["for"]
const _hoisted_103 = ["id", "name", "onUpdate:modelValue", "placeholder"]
const _hoisted_104 = ["for"]
const _hoisted_105 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_106 = ["id", "name", "onUpdate:modelValue", "placeholder"]
const _hoisted_107 = ["for"]
const _hoisted_108 = {
  key: 1,
  class: "grid grid-cols-1 mt-4"
}
const _hoisted_109 = { class: "md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_110 = { class: "grid grid-cols-1 mt-4" }
const _hoisted_111 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_112 = { class: "md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_113 = { class: "mt-3" }
const _hoisted_114 = { class: "md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_115 = { class: "mt-3" }
const _hoisted_116 = { class: "md:text-base text-base text-gray-500 text-light font-semibold" }
const _hoisted_117 = { class: "flex md:gap-8 gap-4 pt-5 pb-5" }
const _hoisted_118 = { class: "flex mx-7 md:gap-8 gap-4 pt-5 pb-5" }
const _hoisted_119 = {
  type: "submit",
  class: "w-auto bg-blue-500 hover:bg-blue-700 rounded-lg shadow-xl font-medium text-white px-4 py-2"
}

import BackButton from "@/components/common/BackButton.vue";
import { computed, onMounted, reactive, ref } from "vue";
import Multiselect from "@vueform/multiselect";
import { StatusesEnum } from "@/store";
import DocumentConstructor from "@/types/documents/documentConstructor/DocumentConstructor";
import DocumentConstructorDataService from "@/services/documents/DocumentConstructor/DocumentConstructorDataService";
import ReceiverTypeFilter from "@/types/documents/documentConstructor/ReceiverTypeFilter";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { required } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { DocumentConstructorActions } from "@/store/modules/documentConstructor/actions";
import { DocumentConstructorGetters } from "@/store/modules/documentConstructor/getters";
import { useToast } from "vue-toastification";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const toast = useToast();

const statusOptions = computed(() => ({
  [StatusesEnum.ACTIVE]: t("docConstructorForm.active"),
  [StatusesEnum.DISABLE]: t("docConstructorForm.disable"),
}));
const receiverTypeOptions = computed(() => ({
  USER: t("docConstructorForm.receiverUser"),
  STRUCTURE: t("docConstructorForm.receiverStructure"),
}));
const receiverFilterTypeOptions = computed(() => ({
  SAME_ORIGIN: t("docConstructorForm.sameOrigin"),
  ALL: t("docConstructorForm.allCompanies"),
  INDIVIDUAL: t("docConstructorForm.individualCompany"),
  IN_CREATOR_COMPANY: t("docConstructorForm.creatorCompany"),
  INDIVIDUAL_WITH_CHILDS: t("docConstructorForm.departmentWithChildren"),
}));
const redirectFilterTypeOptions = computed(() => ({
  SAME_ORIGIN: t("docConstructorForm.creatorCompany"),
  ALL: t("docConstructorForm.allCompanies"),
  INDIVIDUAL: t("docConstructorForm.individualCompany"),
}));

const state = reactive<DocumentConstructor>({
  name: "",
  description: "",
  status: StatusesEnum.ACTIVE,
  params: {
    title: {
      isRequired: true,
      isSelected: true,
    },
    nomenclature: {
      isRequired: true,
      isSelected: true,
    },
    mainFile: {
      isRequired: true,
      isSelected: true,
    },
    subFile: {
      isRequired: false,
      isSelected: false,
    },
    description: {
      isRequired: false,
      isSelected: false,
    },
    price: {
      isRequired: false,
      isSelected: false,
    },
  },
  process: [],
});
const rules = {
  name: { required },
  description: { required },
  status: { required },
  params: {
    title: {
      isRequired: { required },
      isSelected: { required },
    },
    nomenclature: {
      isRequired: { required },
      isSelected: { required },
    },
    mainFile: {
      isRequired: { required },
      isSelected: { required },
    },
    subFile: {
      isRequired: { required },
      isSelected: { required },
    },
    description: {
      isRequired: { required },
      isSelected: { required },
    },
    price: {
      isRequired: { required },
      isSelected: { required },
    },
  },
  process: {},
};
const $externalResults = ref({});
const submitted = ref(false);
const v$ = useVuelidate(rules, state, { $externalResults });

const errors = ref({});

const companies = ref([]);
const roles = ref([]);
const users = ref([]);
const templates = ref([]);

function syncProcessPositions() {
  state.process.forEach((process, index) => {
    process.position = index + 1;
  });
}

function deleteProcess(processIndex: number) {
  state.process.splice(processIndex, 1);
  syncProcessPositions();
}

function changePositionPrev(index: number) {
  if (index <= 0) {
    return;
  }
  const current = state.process.splice(index, 1)[0];
  state.process.splice(index - 1, 0, current);
  syncProcessPositions();
}

function changePositionNext(index: number) {
  if (index < 0 || index >= state.process.length - 1) {
    return;
  }
  const current = state.process.splice(index, 1)[0];
  state.process.splice(index + 1, 0, current);
  syncProcessPositions();
}

function createGuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function addProcess() {
  state.process.push({
    processGuid: createGuid(),
    position: state.process.length + 1,
    templateId: null,
    isRequired: false,
    isSigning: false,
    receiverType: "",
    receiverTypeFilter: {
      companyFilterType: "SAME_ORIGIN",
      companies: null,
      roles: null,
      users: null,
    } as ReceiverTypeFilter | null,
    canRework: false,
    canDeny: false,
    canAnswer: false,
    canReview: false,
    canRedirect: false,
    redirectReceiverTypeFilter: {
      companyFilterType: "SAME_ORIGIN",
      companies: null,
      roles: null,
      users: null,
    } as ReceiverTypeFilter | null,
  });
}

function getCompanies() {
  DocumentConstructorDataService.getCompanies().then((response) => {
    companies.value = response.data.data;
  });
}

function getRoles() {
  DocumentConstructorDataService.getRoles().then((response) => {
    roles.value = response.data.data.items;
  });
}

function getUsers() {
  DocumentConstructorDataService.getUsers().then((response) => {
    users.value = response.data.data.items;
  });
}

function getTemplates() {
  DocumentConstructorDataService.getTemplates().then((response) => {
    templates.value = response.data.data.items;
  });
}

async function handleCreateConstructor() {
  let data = {
    constructor: state,
  };

  await store
    .dispatch(DocumentConstructorActions.CREATE, data.constructor)
    .then(async () => {
      await router.push({ name: "DocumentConstructorList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
}

async function handleUpdateConstructor() {
  let data = {
    constructor: state,
  };

  await store
    .dispatch(DocumentConstructorActions.UPDATE, {
      id: route.params.id,
      data: data.constructor,
    })
    .then(async () => {
      await router.push({ name: "DocumentConstructorList" });
    })
    .catch((error) => {
      $externalResults.value = error.data.data;
    });
}

function errorPop(name: string) {
  errors.value = { ...errors, [name]: "" };
}

async function getConstructor(id: string) {
  await store.dispatch(DocumentConstructorActions.FETCH_ONE, id);

  const documentConstructor =
    store.getters[DocumentConstructorGetters.GET_CURRENT];
  state.id = documentConstructor.id;
  state.name = documentConstructor.name;
  state.status = documentConstructor.status;
  state.params = documentConstructor.params;
  state.process = documentConstructor.process;
  state.description = documentConstructor.description;
}

async function handleSubmit(isFormValid: boolean) {
  submitted.value = true;
  if (!isFormValid) {
    return;
  }

  if (state.process.length <= 0) {
    toast.warning(t("docConstructorForm.needProcesses"));
    return;
  }

  for (const process of state.process) {
    if (
      (process.processMode ?? "TEMPLATE") === "TEMPLATE" &&
      !process.templateId
    ) {
      toast.warning(t("docConstructorForm.processRequired"));
      return;
    }
    if (process.receiverType === "" || process.receiverType === null) {
      toast.warning(t("docConstructorForm.receiverTypeRequired"));
      return;
    }
  }

  syncProcessPositions();

  route.name === "DocumentConstructorEdit"
    ? await handleUpdateConstructor()
    : await handleCreateConstructor();
}

onMounted(async () => {
  getCompanies();

  getRoles();

  getUsers();

  getTemplates();

  if (route.name === "DocumentConstructorEdit") {
    await getConstructor(route.params.id);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'DocumentConstructorList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(route).name === "DocumentConstructorEdit"
            ? _unref(t)("docConstructorForm.titleEdit")
            : _unref(t)("docConstructorForm.titleCreate")), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", {
                  class: _normalizeClass(["input-form-label", { 'p-error': _unref(v$).name.$invalid && submitted.value }]),
                  for: "input-name"
                }, _toDisplayString(_unref(t)("docConstructorForm.name")), 3),
                _withDirectives(_createElementVNode("input", {
                  id: "input-name",
                  class: _normalizeClass(["input-form", {
                  'p-invalid': _unref(v$).name.$invalid && submitted.value,
                }]),
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (errorPop('name'))),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).name.$model) = $event)),
                  type: "text",
                  placeholder: _unref(t)('docConstructorForm.name')
                }, null, 42, _hoisted_7), [
                  [_vModelText, _unref(v$).name.$model]
                ]),
                (_unref(v$).name.$externalResults.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(v$).name.$externalResults[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", {
                  class: _normalizeClass(["input-form-label", {
                  'p-error': _unref(v$).description.$invalid && submitted.value,
                }]),
                  for: "input-description"
                }, _toDisplayString(_unref(t)("docConstructorForm.description")), 3),
                _withDirectives(_createElementVNode("input", {
                  id: "input-description",
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (errorPop('index'))),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).description.$model) = $event)),
                  class: _normalizeClass(["input-form", {
                  'p-invalid': _unref(v$).description.$invalid && submitted.value,
                }]),
                  type: "text",
                  placeholder: _unref(t)('docConstructorForm.descriptionPlaceholder')
                }, null, 42, _hoisted_10), [
                  [_vModelText, _unref(v$).description.$model]
                ]),
                (_unref(v$).description.$externalResults.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_unref(v$).description.$externalResults[0].$message), 1))
                  : _createCommentVNode("", true),
                (errors.value.index)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(errors.value.index), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", {
                  class: _normalizeClass(["input-form-label", {
                  'p-error': _unref(v$).status.$invalid && submitted.value,
                }]),
                  for: "input-description"
                }, _toDisplayString(_unref(t)("common.status")), 3),
                _createVNode(_unref(Multiselect), {
                  id: "input-status",
                  class: _normalizeClass({
                  'p-invalid': _unref(v$).status.$invalid && submitted.value,
                }),
                  modelValue: _unref(v$).status.$model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).status.$model) = $event)),
                  options: _unref(statusOptions)
                }, null, 8, ["class", "modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h2", _hoisted_16, _toDisplayString(_unref(t)("docConstructorForm.params")), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        disabled: "",
                        onChange: _cache[5] || (_cache[5] = ($event: any) => {errorPop('index'); _unref(v$).params.title.isRequired.$model = false}),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).params.title.isSelected.$model) = $event)),
                        class: "p-2 rounded border-1 border-gray-100 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                        type: "checkbox",
                        placeholder: _unref(t)('common.index')
                      }, null, 40, _hoisted_19), [
                        [_vModelCheckbox, _unref(v$).params.title.isSelected.$model]
                      ]),
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(t)("docConstructorForm.subject")), 1)
                    ]),
                    (_unref(v$).params.title.isSelected.$model)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (errorPop('index'))),
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).params.title.isRequired.$model) = $event)),
                              class: "p-2 rounded border border-gray-200 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_23), [
                              [_vModelCheckbox, _unref(v$).params.title.isRequired.$model]
                            ]),
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)("docConstructorForm.filled")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        disabled: "",
                        onChange: _cache[9] || (_cache[9] = ($event: any) => {errorPop('index'); _unref(v$).params.nomenclature.isRequired.$model = false}),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).params.nomenclature.isSelected.$model) = $event)),
                        class: "p-2 rounded border-1 border-gray-100 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                        type: "checkbox",
                        placeholder: _unref(t)('common.index')
                      }, null, 40, _hoisted_27), [
                        [_vModelCheckbox, _unref(v$).params.nomenclature.isSelected.$model]
                      ]),
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_unref(t)("docConstructorForm.nomenclature")), 1)
                    ]),
                    (_unref(v$).params.nomenclature.isSelected.$model)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (errorPop('index'))),
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).params.nomenclature.isRequired.$model) = $event)),
                              class: "p-2 rounded border border-gray-200 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_31), [
                              [_vModelCheckbox, _unref(v$).params.nomenclature.isRequired.$model]
                            ]),
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(t)("docConstructorForm.filled")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        disabled: "",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => {errorPop('index'); _unref(v$).params.mainFile.isRequired.$model = false}),
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(v$).params.mainFile.isSelected.$model) = $event)),
                        class: "p-2 rounded border-1 border-gray-100 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                        type: "checkbox",
                        placeholder: _unref(t)('common.index')
                      }, null, 40, _hoisted_35), [
                        [_vModelCheckbox, _unref(v$).params.mainFile.isSelected.$model]
                      ]),
                      _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(t)("docConstructorForm.mainFile")), 1)
                    ]),
                    (_unref(v$).params.mainFile.isSelected.$model)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("input", {
                              disabled: "",
                              onChange: _cache[15] || (_cache[15] = ($event: any) => (errorPop('index'))),
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(v$).params.mainFile.isRequired.$model) = $event)),
                              class: "p-2 rounded border border-gray-200 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_39), [
                              [_vModelCheckbox, _unref(v$).params.mainFile.isRequired.$model]
                            ]),
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(t)("docConstructorForm.filled")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _withDirectives(_createElementVNode("input", {
                        onChange: _cache[17] || (_cache[17] = ($event: any) => {errorPop('index'); _unref(v$).params.subFile.isRequired.$model = false}),
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(v$).params.subFile.isSelected.$model) = $event)),
                        class: "p-2 rounded border-1 border-gray-100 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                        type: "checkbox",
                        placeholder: _unref(t)('common.index')
                      }, null, 40, _hoisted_43), [
                        [_vModelCheckbox, _unref(v$).params.subFile.isSelected.$model]
                      ]),
                      _createElementVNode("label", _hoisted_44, _toDisplayString(_unref(t)("docConstructorForm.extraFiles")), 1)
                    ]),
                    (_unref(v$).params.subFile.isSelected.$model)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[19] || (_cache[19] = ($event: any) => (errorPop('index'))),
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(v$).params.subFile.isRequired.$model) = $event)),
                              class: "p-2 rounded border border-gray-200 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_47), [
                              [_vModelCheckbox, _unref(v$).params.subFile.isRequired.$model]
                            ]),
                            _createElementVNode("label", _hoisted_48, _toDisplayString(_unref(t)("docConstructorForm.filled")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _withDirectives(_createElementVNode("input", {
                        onChange: _cache[21] || (_cache[21] = ($event: any) => {errorPop('index'); _unref(v$).params.description.isRequired.$model = false}),
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(v$).params.description.isSelected.$model) = $event)),
                        class: "p-2 rounded border-1 border-gray-100 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                        type: "checkbox",
                        placeholder: _unref(t)('common.index')
                      }, null, 40, _hoisted_51), [
                        [_vModelCheckbox, _unref(v$).params.description.isSelected.$model]
                      ]),
                      _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(t)("docConstructorForm.paramDescription")), 1)
                    ]),
                    (_unref(v$).params.description.isSelected.$model)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[23] || (_cache[23] = ($event: any) => (errorPop('index'))),
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(v$).params.description.isRequired.$model) = $event)),
                              class: "p-2 rounded border border-gray-200 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_55), [
                              [_vModelCheckbox, _unref(v$).params.description.isRequired.$model]
                            ]),
                            _createElementVNode("label", _hoisted_56, _toDisplayString(_unref(t)("docConstructorForm.filled")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _withDirectives(_createElementVNode("input", {
                        onChange: _cache[25] || (_cache[25] = ($event: any) => {errorPop('index'); _unref(v$).params.price.isRequired.$model = false}),
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(v$).params.price.isSelected.$model) = $event)),
                        class: "p-2 rounded border-1 border-gray-100 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                        type: "checkbox",
                        placeholder: _unref(t)('common.index')
                      }, null, 40, _hoisted_59), [
                        [_vModelCheckbox, _unref(v$).params.price.isSelected.$model]
                      ]),
                      _createElementVNode("label", _hoisted_60, _toDisplayString(_unref(t)("docConstructorForm.paramPrice")), 1)
                    ]),
                    (_unref(v$).params.price.isSelected.$model)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[27] || (_cache[27] = ($event: any) => (errorPop('index'))),
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(v$).params.price.isRequired.$model) = $event)),
                              class: "p-2 rounded border border-gray-200 mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_63), [
                              [_vModelCheckbox, _unref(v$).params.price.isRequired.$model]
                            ]),
                            _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(t)("docConstructorForm.filled")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createVNode(_TransitionGroup, {
              name: "list-complete",
              tag: "ul",
              class: "process-list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).process.$model, (processes, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: processes.processGuid,
                    class: "list-complete-item process-list-item w-full bg-white rounded-md mt-5"
                  }, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "process-move-btn text-green-500",
                        disabled: index === 0,
                        title: _unref(t)('docForm.moveUp'),
                        onClick: _withModifiers(($event: any) => (changePositionPrev(index)), ["prevent"])
                      }, _hoisted_68, 8, _hoisted_66),
                      _createElementVNode("button", {
                        type: "button",
                        class: "process-move-btn text-green-500",
                        disabled: index === _unref(state).process.length - 1,
                        title: _unref(t)('docForm.moveDown'),
                        onClick: _withModifiers(($event: any) => (changePositionNext(index)), ["prevent"])
                      }, _hoisted_71, 8, _hoisted_69),
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex items-center justify-center text-center cursor-pointer w-10 h-10 m-1 p-2 rounded-full text-red-500",
                        style: {"font-size":"1.5rem","border":"4px solid red"},
                        title: _unref(t)('docForm.removeProcess'),
                        onClick: ($event: any) => (deleteProcess(index))
                      }, _hoisted_74, 8, _hoisted_72)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("label", _hoisted_77, _toDisplayString(_unref(t)("docConstructorForm.process")), 1),
                        _createVNode(_unref(Multiselect), {
                          modelValue: processes.templateId,
                          "onUpdate:modelValue": ($event: any) => ((processes.templateId) = $event),
                          name: _unref(v$).process.$model[index]['templateId'],
                          options: templates.value,
                          valueProp: "id",
                          "track-by": "name",
                          label: "name",
                          placeholder: _unref(t)('docConstructorForm.processPlaceholder')
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options", "placeholder"])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _withDirectives(_createElementVNode("input", {
                            id: 'document-constructor-process-is-required' + index,
                            onChange: _cache[29] || (_cache[29] = ($event: any) => (errorPop('index'))),
                            name: _unref(v$).process.$model[index]['isRequired'],
                            "onUpdate:modelValue": ($event: any) => ((processes.isRequired) = $event),
                            class: "p-2 border border-gray-300 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                            type: "checkbox",
                            placeholder: _unref(t)('common.index')
                          }, null, 40, _hoisted_80), [
                            [_vModelCheckbox, processes.isRequired]
                          ]),
                          _createElementVNode("label", {
                            for: 'document-constructor-process-is-required' + index,
                            class: "input-form-label input-form-label--checkbox"
                          }, _toDisplayString(_unref(t)("docConstructorForm.filling")), 9, _hoisted_81)
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _withDirectives(_createElementVNode("input", {
                            id: 'document-constructor-process-is-signing' + index,
                            onChange: _cache[30] || (_cache[30] = ($event: any) => (errorPop('index'))),
                            name: _unref(v$).process.$model[index]['isSigning'],
                            "onUpdate:modelValue": ($event: any) => ((processes.isSigning) = $event),
                            class: "p-2 border border-gray-300 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                            type: "checkbox",
                            placeholder: _unref(t)('common.index')
                          }, null, 40, _hoisted_83), [
                            [_vModelCheckbox, processes.isSigning]
                          ]),
                          _createElementVNode("label", {
                            for: 'document-constructor-process-is-signing' + index,
                            class: "input-form-label input-form-label--checkbox"
                          }, _toDisplayString(_unref(t)("docConstructorForm.signEcp")), 9, _hoisted_84)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("label", _hoisted_86, _toDisplayString(_unref(t)("docConstructorForm.receiverType")), 1),
                        _createVNode(_unref(Multiselect), {
                          modelValue: processes.receiverType,
                          "onUpdate:modelValue": ($event: any) => ((processes.receiverType) = $event),
                          name: _unref(v$).process.$model[index]['receiverType'],
                          options: _unref(receiverTypeOptions)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                      ]),
                      (processes.receiverType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_88, _toDisplayString(_unref(t)("docConstructorForm.filterType")), 1),
                              _createVNode(_unref(Multiselect), {
                                modelValue: processes.receiverTypeFilter.companyFilterType,
                                "onUpdate:modelValue": ($event: any) => ((processes.receiverTypeFilter.companyFilterType) = $event),
                                name: 
                        _unref(v$).process.$model[index]['receiverTypeFilter'][
                          'companyFilterType'
                        ]
                      ,
                                options: _unref(receiverFilterTypeOptions)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                            ]),
                            (
                      processes.receiverTypeFilter.companyFilterType ===
                        'INDIVIDUAL' ||
                      (processes.receiverType === 'USER' &&
                        processes.receiverTypeFilter.companyFilterType ===
                          'INDIVIDUAL') ||
                      (processes.receiverType === 'USER' &&
                        processes.receiverTypeFilter.companyFilterType ===
                          'INDIVIDUAL_WITH_CHILDS')
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                  _createElementVNode("label", _hoisted_90, _toDisplayString(_unref(t)("docConstructorForm.companies")), 1),
                                  _createVNode(_unref(Multiselect), {
                                    mode: "tags",
                                    object: false,
                                    modelValue: processes.receiverTypeFilter.companies,
                                    "onUpdate:modelValue": ($event: any) => ((processes.receiverTypeFilter.companies) = $event),
                                    name: 
                        _unref(v$).process.$model[index]['receiverTypeFilter'][
                          'companies'
                        ]
                      ,
                                    valueProp: "id",
                                    "track-by": "name",
                                    label: "name",
                                    options: companies.value
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                                ]))
                              : _createCommentVNode("", true),
                            (processes.receiverType === 'USER')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                  _createElementVNode("label", _hoisted_92, _toDisplayString(_unref(t)("docConstructorForm.role")), 1),
                                  _createVNode(_unref(Multiselect), {
                                    mode: "tags",
                                    object: false,
                                    modelValue: processes.receiverTypeFilter.roles,
                                    "onUpdate:modelValue": ($event: any) => ((processes.receiverTypeFilter.roles) = $event),
                                    name: 
                        _unref(v$).process.$model[index]['receiverTypeFilter']['roles']
                      ,
                                    valueProp: "id",
                                    "track-by": "name",
                                    label: "name",
                                    options: roles.value
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                                ]))
                              : _createCommentVNode("", true),
                            (processes.receiverType === 'USER')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                  _createElementVNode("label", _hoisted_94, _toDisplayString(_unref(t)("docConstructorForm.users")), 1),
                                  _createVNode(_unref(Multiselect), {
                                    mode: "tags",
                                    object: false,
                                    modelValue: processes.receiverTypeFilter.users,
                                    "onUpdate:modelValue": ($event: any) => ((processes.receiverTypeFilter.users) = $event),
                                    name: 
                        _unref(v$).process.$model[index]['receiverTypeFilter']['users']
                      ,
                                    options: users.value,
                                    valueProp: "id",
                                    "track-by": "fullName",
                                    label: "fullName"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              id: 'document-constructor-can-rework' + index,
                              onChange: _cache[31] || (_cache[31] = ($event: any) => (errorPop('index'))),
                              name: _unref(v$).process.$model[index]['canRework'],
                              "onUpdate:modelValue": ($event: any) => ((processes.canRework) = $event),
                              class: "p-2 border border-gray-200 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_97), [
                              [_vModelCheckbox, processes.canRework]
                            ]),
                            _createElementVNode("label", {
                              for: 'document-constructor-can-rework' + index,
                              class: "input-form-label input-form-label--checkbox"
                            }, _toDisplayString(_unref(t)("docConstructorForm.rework")), 9, _hoisted_98)
                          ]),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              id: 'document-constructor-can-deny' + index,
                              onChange: _cache[32] || (_cache[32] = ($event: any) => (errorPop('index'))),
                              name: _unref(v$).process.$model[index]['canDeny'],
                              "onUpdate:modelValue": ($event: any) => ((processes.canDeny) = $event),
                              class: "p-2 border border-gray-200 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_99), [
                              [_vModelCheckbox, processes.canDeny]
                            ]),
                            _createElementVNode("label", {
                              for: 'document-constructor-can-deny' + index,
                              class: "input-form-label input-form-label--checkbox"
                            }, _toDisplayString(_unref(t)("docConstructorForm.deny")), 9, _hoisted_100)
                          ]),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              id: 'document-constructor-can-answer' + index,
                              onChange: _cache[33] || (_cache[33] = ($event: any) => (errorPop('index'))),
                              name: _unref(v$).process.$model[index]['canAnswer'],
                              "onUpdate:modelValue": ($event: any) => ((processes.canAnswer) = $event),
                              class: "p-2 border border-gray-200 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_101), [
                              [_vModelCheckbox, processes.canAnswer]
                            ]),
                            _createElementVNode("label", {
                              for: 'document-constructor-can-answer' + index,
                              class: "input-form-label input-form-label--checkbox"
                            }, _toDisplayString(_unref(t)("docConstructorForm.answer")), 9, _hoisted_102)
                          ]),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                              id: 'document-constructor-can-review' + index,
                              onChange: _cache[34] || (_cache[34] = ($event: any) => (errorPop('index'))),
                              name: _unref(v$).process.$model[index]['canReview'],
                              "onUpdate:modelValue": ($event: any) => ((processes.canReview) = $event),
                              class: "p-2 border border-gray-200 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                              type: "checkbox",
                              placeholder: _unref(t)('common.index')
                            }, null, 40, _hoisted_103), [
                              [_vModelCheckbox, processes.canReview]
                            ]),
                            _createElementVNode("label", {
                              for: 'document-constructor-can-review' + index,
                              class: "input-form-label input-form-label--checkbox"
                            }, _toDisplayString(_unref(t)("docConstructorForm.review")), 9, _hoisted_104)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            id: 'document-constructor-can-redirect' + index,
                            onChange: _cache[35] || (_cache[35] = ($event: any) => (errorPop('index'))),
                            name: _unref(v$).process.$model[index]['canRedirect'],
                            "onUpdate:modelValue": ($event: any) => ((processes.canRedirect) = $event),
                            class: "p-2 border border-gray-300 rounded mt-1 focus:outline-none focus:ring-2 focus:ring-primary-300 text-primary-300 focus:border-transparent",
                            type: "checkbox",
                            placeholder: _unref(t)('common.index')
                          }, null, 40, _hoisted_106), [
                            [_vModelCheckbox, processes.canRedirect]
                          ]),
                          _createElementVNode("label", {
                            for: 'document-constructor-can-redirect' + index,
                            class: "input-form-label input-form-label--checkbox"
                          }, _toDisplayString(_unref(t)("docConstructorForm.transfer")), 9, _hoisted_107)
                        ])
                      ]),
                      (processes.canRedirect)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            _createElementVNode("div", null, [
                              _createElementVNode("label", _hoisted_109, _toDisplayString(_unref(t)("docConstructorForm.filteringType")), 1),
                              _createVNode(_unref(Multiselect), {
                                modelValue: 
                        processes.redirectReceiverTypeFilter.companyFilterType
                      ,
                                "onUpdate:modelValue": ($event: any) => ((
                        processes.redirectReceiverTypeFilter.companyFilterType
                      ) = $event),
                                name: 
                        _unref(v$).process.$model[index]['redirectReceiverTypeFilter'][
                          'companyFilterType'
                        ]
                      ,
                                options: _unref(redirectFilterTypeOptions)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              (
                        processes.redirectReceiverTypeFilter === 'INDIVIDUAL'
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                                    _createElementVNode("label", _hoisted_112, _toDisplayString(_unref(t)("docConstructorForm.companies")), 1),
                                    _createVNode(_unref(Multiselect), {
                                      mode: "tags",
                                      object: false,
                                      modelValue: processes.redirectReceiverTypeFilter.companies,
                                      "onUpdate:modelValue": ($event: any) => ((processes.redirectReceiverTypeFilter.companies) = $event),
                                      name: 
                          _unref(v$).process.$model[index][
                            'redirectReceiverTypeFilter'
                          ]['companies']
                        ,
                                      options: companies.value,
                                      valueProp: "id",
                                      "track-by": "name",
                                      label: "name"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_113, [
                                _createElementVNode("label", _hoisted_114, _toDisplayString(_unref(t)("docConstructorForm.role")), 1),
                                _createVNode(_unref(Multiselect), {
                                  mode: "tags",
                                  object: false,
                                  modelValue: processes.redirectReceiverTypeFilter.roles,
                                  "onUpdate:modelValue": ($event: any) => ((processes.redirectReceiverTypeFilter.roles) = $event),
                                  name: 
                          _unref(v$).process.$model[index][
                            'redirectReceiverTypeFilter'
                          ]['roles']
                        ,
                                  options: roles.value,
                                  valueProp: "id",
                                  "track-by": "name",
                                  label: "name"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                              ]),
                              _createElementVNode("div", _hoisted_115, [
                                _createElementVNode("label", _hoisted_116, _toDisplayString(_unref(t)("docConstructorForm.users")), 1),
                                _createVNode(_unref(Multiselect), {
                                  mode: "tags",
                                  object: false,
                                  modelValue: processes.redirectReceiverTypeFilter.users,
                                  "onUpdate:modelValue": ($event: any) => ((processes.redirectReceiverTypeFilter.users) = $event),
                                  name: 
                          _unref(v$).process.$model[index][
                            'redirectReceiverTypeFilter'
                          ]['users']
                        ,
                                  options: users.value,
                                  valueProp: "id",
                                  "track-by": "fullName",
                                  label: "fullName"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "options"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("a", {
                onClick: addProcess,
                class: "add-process p-4 border-2 border-dashed border-blue-500 text-center w-full text-green-500 rounded-lg cursor-pointer"
              }, _toDisplayString(_unref(t)("docConstructorForm.addProcess")), 1)
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("button", _hoisted_119, _toDisplayString(_ctx.$route.name === "DocumentConstructorEdit"
                  ? _unref(t)("docConstructorForm.update")
                  : _unref(t)("docConstructorForm.create")), 1)
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}
}

})